import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Theme } from '../../utils/Theme';
import { withStyles } from '@material-ui/styles';
import {
    setAuthAlert,
    getAuthAlert,
} from '../../redux/actions/siteSettingsActions';
import AdminLayout from '../layout/AdminLayout';
import TextAreaFieldGroup from '../common/TextAreaFieldGroup';
import TextFieldGroup from '../common/TextFieldGroup';
import SelectFieldGroup from '../common/SelectFieldGroup';
import { Button, Box } from '@material-ui/core';
import Loading from '../common/Loading';
import Header from '../layout/Partials/Header';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Section from '../UI/Section';
import { Helmet } from 'react-helmet';

const styles = Theme();

class AuthAlert extends Component {
    constructor() {
        super();
        this.state = {
            errors: {},
            loading: true,
            subject: '',
            status: '',
            message: '',
            initialLoad: true,
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }
    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    componentDidMount() {
        if (!this.props.settings.alert) {
            this.props.getAuthAlert();
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { status, message, subject } = this.state;
        this.props.setAuthAlert({ status, message, subject });
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        let { initialLoad, status, message, subject, errors } = prevState;
        if (!nextProps.settings.loading && initialLoad) {
            if (nextProps.settings.alert) {
                status = nextProps.settings.alert.status;
                message = nextProps.settings.alert.message;
                subject = nextProps.settings.alert.subject;
                initialLoad = false;
            }
        }
        errors = nextProps.errors;

        let loading = nextProps.settings.loading;

        return { initialLoad, status, message, subject, loading, errors };
    }

    render() {
        const { errors, loading, subject, status, message } = this.state;
        const { classes } = this.props;

        return (
            <AdminLayout>
                <Helmet>
                    <title>Auth Alert</title>
                </Helmet>
                <div className="o-page">
                    <Header
                        classes={classes}
                        title={'Login Notification'}
                        hideSearchBar
                    />
                    {!loading && (
                        <Box className={clsx('u-m-xsmall')}>
                            <Section>
                                <div className="container u-p-small">
                                    <div className="row">
                                        <div className="col-md-8 col-xl-8 u-m-auto">
                                            <div className="u-p-small">
                                                <div className="o-line">
                                                    <span className="c-icon c-icon--large u-mb-small">
                                                        <Icon.AlertOctagon
                                                            className={
                                                                classes.colorInfo
                                                            }
                                                        />
                                                    </span>
                                                    <h5
                                                        className={clsx(
                                                            'u-mb-xsmall'
                                                        )}
                                                    >
                                                        Login Alert
                                                    </h5>
                                                </div>

                                                <form
                                                    noValidate
                                                    onSubmit={this.onSubmit}
                                                >
                                                    <TextFieldGroup
                                                        error={errors?.subject}
                                                        value={subject || ''}
                                                        label={'Alert Title'}
                                                        onChange={this.onChange}
                                                        name={'subject'}
                                                    />
                                                    <SelectFieldGroup
                                                        options={[
                                                            {
                                                                key: 'active',
                                                                title: 'Active',
                                                            },
                                                            {
                                                                key: 'inactive',
                                                                title:
                                                                    'Inactive',
                                                            },
                                                        ]}
                                                        error={errors?.status}
                                                        value={
                                                            status || 'inactive'
                                                        }
                                                        label={'Alert Status'}
                                                        onChange={this.onChange}
                                                        name={'status'}
                                                    />
                                                    <TextAreaFieldGroup
                                                        error={errors?.message}
                                                        rows={7}
                                                        value={message || ''}
                                                        label={
                                                            'Auth Alert Message'
                                                        }
                                                        onChange={this.onChange}
                                                        name={'message'}
                                                    />
                                                    <div className="o-line">
                                                        <div className="">
                                                            <Button
                                                                type="submit"
                                                                className={`c-btn ${classes.buttonPrimary} has-arrow u-text-center`}
                                                            >
                                                                Save Details
                                                            </Button>
                                                        </div>
                                                        <div className="">
                                                            <Button
                                                                type="button"
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    this.props.history.goBack();
                                                                }}
                                                                className={`c-btn ${classes.buttonSecondary} has-arrow u-text-center`}
                                                            >
                                                                Cancel
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Section>
                        </Box>
                    )}
                    {loading && <Loading />}
                </div>
            </AdminLayout>
        );
    }
}

AuthAlert.propTypes = {
    authAlert: PropTypes.object,
    setAuthAlert: PropTypes.func,
    getAuthAlert: PropTypes.func,
    classes: PropTypes.object,
    history: PropTypes.object,
    settings: PropTypes.object,
    errors: PropTypes.object,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    authAlert: state.auth.alert,
    settings: state.settings,
    errors: state.settings.errors,
});

export default connect(mapStateToProps, { setAuthAlert, getAuthAlert })(
    withStyles(styles)(AuthAlert)
);
